// removed by extract-text-webpack-plugin
module.exports = {"PageSection":"_2A8cFf6nIWe6ALGt-R1HwG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PageSection/PageSection.scss
// module id = 2649
// module chunks = 0